module.exports = __webpack_public_path__ + "img/hr-ccm-inserter-01-base-sequence.46bdfd8e.png";